import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { GrupoAppRoutingModule } from "./grupo.app-routing.module"; 

@NgModule({
    imports: [
        CommonModule,     
        GrupoAppRoutingModule   
    ],
    declarations: [
      
    ]
})
export class GrupoAppModule { }
